module.exports = __webpack_public_path__ + "static/media/thumbnail-harbegona.7a672566.jpg";